import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PopoverDirective } from "./popover.directive";
import { Overlay, OverlayModule } from "@angular/cdk/overlay";
import { PopoverService } from "./popover.service";
import { PopovercomponentComponent } from "./popovercomponent/popovercomponent.component";

@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [PopoverDirective, PopovercomponentComponent],
  exports: [PopoverDirective, PopovercomponentComponent],
  providers: [Overlay, PopoverService]
})
export class PopoverModule {}
